import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import type { Card } from 'src/types';

import { updateRoute } from './actionCreators';

export const useEnterReadMode = (card: Card) => {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(updateRoute({ to: card, mode: 'READ' }));
  }, [card, dispatch]);
};
